/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const GenesysSvg = () => (
  <svg
    width="1.1em"
    height="1.1em"
    viewBox="0 0 20 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#FF4F1F"
      d="M20.3,2.3c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8c0,0-0.1,0-0.1,0c-0.9,0-1.7-0.8-1.7-1.7   c0-0.5,0.2-1,0.5-1.3C19.3,2.5,19.8,2.3,20.3,2.3 M20.3,0c-2.3,0-4.2,2-4.1,4.3c0.1,2.1,1.8,3.8,3.9,3.9c0.1,0,0.1,0,0.2,0   c2.3,0,4.1-1.9,4.1-4.1S22.5,0,20.3,0L20.3,0z"></path>
    <path
      d="M17.5,28.9c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2H13c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2H17.5 M17.5,26.1  H13c-3.8,0-6.9,3.1-6.9,6.9c0,3.8,3.1,6.9,6.9,6.9h4.5c3.8,0,6.9-3.1,6.9-6.9C24.4,29.2,21.3,26.1,17.5,26.1L17.5,26.1z"
      fill="#FF4F1F"></path>
    <path
      d="M17.5,12.7c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2H6.9c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2H17.5 M17.5,10  H6.9C3.1,10,0,13.1,0,16.9c0,3.8,3.1,6.9,6.9,6.9h10.6c3.8,0,6.9-3.1,6.9-6.9C24.4,13.1,21.3,10,17.5,10L17.5,10z"
      fill="#FF4F1F"></path>
  </svg>
);

export const GenesysIcon = (props) => (
  <Icon component={GenesysSvg} {...props} />
);
